import styled from "styled-components";

export const FormDiv = styled.div`

.container{
max-width: 400px;
width: 100%;
margin: 0 auto;
position: relative;

#contact {
  background: #f9f9f9;   padding: 25px;
  margin: 150px 0;
   box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24); 
   textarea:hover {
   -webkit-transition: border-color 0.3s ease-in-out;
   -moz-transition: border-color 0.3s ease-in-out;
   transition: border-color 0.3s ease-in-out;
   border: 1px solid #aaa;
   height: 100px;
   max-width: 100%;
   resize: none;
   input:focus,
   ::-webkit-input-placeholder {
   color: #888;
 }

 :-moz-placeholder {
   color: #888;
 }

 ::-moz-placeholder {
   color: #888;
 }

 :-ms-input-placeholder {
   color: #888;
 }

}


hr{
    display: block;
   font-size: 30px;
  font-weight: 300;
 margin-bottom: 10px;
}
fieldset {
   border: medium none !important;
   margin: 0 0 10px;
  min-width: 100%;
   padding: 0;
  width: 100%;
 }


#upload{
    cursor: pointer;
 width: 100%;
border: none;
   background: #4caf50;
  color: #fff;
  margin: 0 0 5px;
     padding: 10px;
   font-size: 15px;
   font: 400 12px/16px "Roboto", Helvetica, Arial, sans-serif;
   



:hover {
   background: #43a047;
   -webkit-transition: background 0.3s ease-in-out;
   -moz-transition: background 0.3s ease-in-out;
   transition: background-color 0.3s ease-in-out;
 
} 
:active {
   box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.5);
}
}
 
`;
